import styled from 'styled-components';
import { TextStyles } from '@/constants';
import { Button, Typography } from '@/components';

export const NotiContainer = styled.div<{
  hidden: boolean;
}>(({ hidden }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  transition: 'opacity 0.3s, visibility 0.3s',

  ...(hidden && {
    opacity: 0,
    visibility: 'hidden',
  }),
}));

export const NotiText = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})<{ isMobile?: boolean }>`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  margin-top: ${({ theme }) => theme.spacing[8]};

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    ${({ isMobile }) =>
      isMobile &&
      `
      display: none;
    `}
  }
`;

export const NotiButton = styled(Button)<{
  isMobile?: boolean;
  hasDefaultCursor?: boolean;
}>`
  width: 100%;
  text-transform: uppercase;

  > span {
    word-break: break-word;
  }

  ${({ theme, hasDefaultCursor }) =>
    hasDefaultCursor &&
    `
    cursor: default;

    &:hover {
      background: ${theme.colors.darkOrange} !important;
    }
  `}

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    ${({ isMobile }) =>
      isMobile &&
      `
      display: none;
    `}
  }
`;
